export type HomeCardKey =
  | "quote"
  | "gamification"
  | "continue"
  | "brainBuilder"
  | "learningQueue"
  | "vital7";

export type HomeCardsPreferences = Record<HomeCardKey, boolean>;

export const HOME_CARDS_STORAGE_KEY = "deeply_home_cards";
const LEGACY_SHOW_EXTRAS_KEY = "deeply_home_show_extras";

// DS EDIT 5aug26 — "search" card retired: universal search now lives as an icon in the
// chat header row (opens the pop-out universal search).
export const HOME_CARD_LABELS: Record<HomeCardKey, string> = {
  quote: "Daily quote",
  gamification: "Progress & gamification",
  continue: "Continue where you left off",
  brainBuilder: "Brain builder workout",
  learningQueue: "Learning queue",
  vital7: "Vital7 dashboard",
};

export const DEFAULT_HOME_CARDS: HomeCardsPreferences = {
  quote: false,
  gamification: false,
  continue: false,
  brainBuilder: false,
  learningQueue: false,
  vital7: false,
};

function migrateLegacyExtras(prefs: HomeCardsPreferences): HomeCardsPreferences {
  if (typeof window === "undefined") return prefs;
  try {
    const legacy = localStorage.getItem(LEGACY_SHOW_EXTRAS_KEY);
    if (legacy === "true") {
      return { ...prefs, quote: true };
    }
  } catch {
    /* ignore */
  }
  return prefs;
}

export function readHomeCardsPreferences(): HomeCardsPreferences {
  if (typeof window === "undefined") {
    return { ...DEFAULT_HOME_CARDS };
  }
  try {
    const raw = localStorage.getItem(HOME_CARDS_STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as Partial<HomeCardsPreferences>;
      const merged = { ...DEFAULT_HOME_CARDS };
      for (const key of Object.keys(DEFAULT_HOME_CARDS) as HomeCardKey[]) {
        if (typeof parsed[key] === "boolean") {
          merged[key] = parsed[key]!;
        }
      }
      return merged;
    }
    return migrateLegacyExtras({ ...DEFAULT_HOME_CARDS });
  } catch {
    return migrateLegacyExtras({ ...DEFAULT_HOME_CARDS });
  }
}

export function writeHomeCardsPreferences(prefs: HomeCardsPreferences): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(HOME_CARDS_STORAGE_KEY, JSON.stringify(prefs));
    localStorage.removeItem(LEGACY_SHOW_EXTRAS_KEY);
  } catch {
    /* private mode / quota */
  }
}

export function anyHomeCardEnabled(prefs: HomeCardsPreferences): boolean {
  return (Object.keys(DEFAULT_HOME_CARDS) as HomeCardKey[]).some((k) => prefs[k]);
}
